import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { ButtonBase, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { loginLink } from "../../common/routes";
import { useCookies } from "react-cookie";

const LoginButton = styled(ButtonBase)`
  && {
    position: relative;
    top: 45px;
    margin-top: -15px;

    width: 175px;
    height: 50px;
    background: #f2753b;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

const NotifyText = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export default function LoginDialog({ open }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies();
  const path = "/";
  const domain = window.location.hostname;

  function clearCookie() {
    setCookie("emailID", undefined, { path, domain });
    setCookie("firstName", undefined, { path, domain });
    setCookie("lastName", undefined, { path, domain });
    setCookie("userID", undefined, { path, domain });
    setCookie("token", undefined, { path, domain });
    removeCookie("emailID");
    removeCookie("firstName");
    removeCookie("lastName");
    removeCookie("userID");
    removeCookie("token");
    navigate(loginLink, { state: { from: location } })
  }


  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent sx={{ width: { md: 525 }, height: 200 }}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ height: "100%" }}
        >
          <NotifyText sx={{ fontSize: "30px" }}>Session Expired.</NotifyText>
          <NotifyText sx={{ fontSize: "28px" }}>Please Log In!</NotifyText>
          <LoginButton
            onClick={clearCookie}
          >
            login
          </LoginButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
